import React from "react";
import { Link } from "react-router-dom";
import Book1 from "../../assets/Simdozi-BookArtboard-1.png";
import Book2 from "../../assets/Simdozi-BookArtboard-2.png";
import TextEffect from "../CustomTexts/TextEffect";

const books = [
  {
    id: 1,
    title: "Commercial Orange fleshed: Sweet Potato farming",
    author: "John Abraham Godson & Esonu Nduka Udeala",
    image: Book1,
    quote: "The orange-fleshed sweet potato is the new breed that is bio-fortified and contains high amount of beta-carotene......",
    rating: 4.1,
  },
  {
    id: 2,
    title: "Training Manual On Production & Utilization",
    author: "Esonu Nduka Udeala",
    image: Book2,
    quote: "Your essential manual to thriving in modern agro-economy.Published in 2021....",
    rating: 4.7,
  },
];

const BookAdsSection = () => {
  return (
    <div className="w-full px-6 md:px-24 py-20 bg-gray-100">
      <div className="max-w-5xl mx-auto text-center mb-16 animate-fade-in-up">
        <h1 className="md:text-[60px] text-[30px] font-bold text-dark mb-6 leading-tight transition-opacity duration-1000">
          <TextEffect part=" Discover Our Latest Book" />{" "}
          <TextEffect part5="Releases." />
        </h1>
        <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto transition-opacity duration-1000 delay-200">
          The orange-fleshed sweet potato is the new breed that is bio-fortified and contains high amount of beta-carotene. It is also good in vitamin A and other nutrients.
        </p>
      </div>

      <div className="grid gap-12 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-center animate-fade-in-up delay-300">
        {books.map((book) => (
          <div
            key={book.id}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 w-full max-w-sm p-5 flex flex-col justify-between min-h-[600px] transform transition duration-300 hover:scale-[1.03] hover:shadow-2xl"
          >
            <img
              src={book.image}
              alt={book.title}
              className="w-full h-80 object-cover rounded-lg mb-5"
            />
            <div>
              <h3 className="text-xl font-semibold text-gray-800">{book.title}</h3>
              <p className="text-sm text-gray-500 italic mt-1 mb-2">By {book.author}</p>
              <p className="text-sm text-gray-700 mb-4">“{book.quote}”</p>
              <div className="flex items-center text-yellow-500 text-sm mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i}>{i < Math.floor(book.rating) ? "★" : "☆"}</span>
                ))}
                {book.rating % 1 > 0 && <span className="-ml-1">½</span>}
              </div>
              <Link
                to="/services/gallery"
                className="text-green-700 font-medium text-sm hover:underline"
              >
                → Read more in gallery
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookAdsSection;
